// DONM3/services/frontend/src/services/api.js
export class ApiService {
  constructor() {
    this.baseUrl = '/api'
  }

  async getHierarchy() {
    try {
      const response = await fetch(`${this.baseUrl}/hierarchy`)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const data = await response.json()
      
      // Проверяем структуру данных
      if (!Array.isArray(data)) {
        throw new Error('Данные должны быть массивом')
      }
      
      console.log('API response:', {
        total: data.length,
        sample: data.slice(0, 3)
      })
      
      return data
    } catch (error) {
      console.error('Ошибка загрузки данных:', error)
      throw new Error(`Не удалось загрузить данные: ${error.message}`)
    }
  }

  async searchEmployees(query) {
    try {
      const response = await fetch(`${this.baseUrl}/hierarchy?search=${encodeURIComponent(query)}`)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      return await response.json()
    } catch (error) {
      console.error('Ошибка поиска:', error)
      return []
    }
  }
}
